<script setup>
const { columns = 4 } = defineProps({
    columns: {
        type: Number,
        required: false,
    },
});
</script>

<template>
    <div
        class="grid grid-cols-1 gap-x-8"
        :class="{
            'lg:grid-cols-2': columns === 2,
            'md:grid-cols-2 lg:grid-cols-3': columns === 3,
            'md:grid-cols-2 lg:grid-cols-4': columns === 4,
        }"
    >
        <slot />
    </div>
</template>
